import { formatDateFromISO } from '@practium/shared';
import { TableEmptyState } from '@practium/ui';
import type { RecommendationTableRow } from '../../../types';
import styles from './RecommendationsTable.module.css';

interface RecommendationsTableProps {
	rows: RecommendationTableRow[];
	onRowClick?: (id: string) => void;
}

export const RecommendationsTable = ({ rows, onRowClick }: RecommendationsTableProps) => {
	if (rows.length === 0) {
		return (
			<TableEmptyState
				title="Nenhuma recomendação encontrada"
				subtitle="Adicione uma recomendação para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Identificação</th>
						<th>Propriedade</th>
						<th>Área</th>
						<th>Setor</th>
						<th>Data</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{rows.map((row) => (
						<tr
							key={row._id}
							onClick={() => onRowClick?.(row._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{row.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{row.prop}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{row.area}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{row.sector}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{formatDateFromISO(row.date)}</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
